<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title"><span class="bold">Contents</span></h1>
<h2 class="toc"><a href="#/xhtml/06_Acknowledgements">Acknowledgements</a></h2>
<h2 class="tocb"><a href="#/xhtml/07_Introduction">Introduction</a></h2>
<h2 class="tocc"><a href="#/xhtml/08_Chapter01"><span class="tocc">Chapter 1</span> Lucius Artorius Castus</a></h2>
<h2 class="tocc"><span href="#/xhtml/09_Chapter02" title="Link target outside of Sample"><span class="tocc">Chapter 2</span> The legend of King Arthur</span></h2>
<h2 class="tocc"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample"><span class="tocc">Chapter 3</span> Lucius Artorius Castus and the History of Rome <span class="smallcaps">AD</span> 150–250</span></h2>
<h2 class="tocc"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample"><span class="tocc">Chapter 4</span> The Sarmatians</span></h2>
<h2 class="tocc"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample"><span class="tocc">Chapter 5</span> Lucius Artorius Castus: Timeframes and options</span></h2>
<h2 class="tocc"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample"><span class="tocc">Chapter 6</span> Cerdic and the coming of the Saxons</span></h2>
<h2 class="tocc"><span href="#/xhtml/14_Chapter07" title="Link target outside of Sample"><span class="tocc">Chapter 7</span> Who was King Arthur?</span></h2>
<h2 class="tocc"><span href="#/xhtml/15_Chapter08" title="Link target outside of Sample"><span class="tocc">Chapter 8</span> Conclusion</span></h2>
<h2 class="toct"><span href="#/xhtml/16_Sources" title="Link target outside of Sample">Sources for images and figures</span></h2>
<h2 class="toc"><span href="#/xhtml/17_References" title="Link target outside of Sample">References</span></h2>
<h2 class="toc"><span href="#/xhtml/18_Endnotes" title="Link target outside of Sample">Endnotes</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?08532cfd